import { render, staticRenderFns } from "./AlsoInThis.vue?vue&type=template&id=f8add624&scoped=true"
import script from "./AlsoInThis.vue?vue&type=script&lang=js"
export * from "./AlsoInThis.vue?vue&type=script&lang=js"
import style0 from "./AlsoInThis.vue?vue&type=style&index=0&id=f8add624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8add624",
  null
  
)

export default component.exports